import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { SearchResultViewTracker, getMarketplaceInteractionEvent, getSearchResultClickedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { EcosystemCardSmall } from 'trellis-ecosystem';
import { getSourceIdByCard } from '../utils/usageTracker';
import { CollectionCard } from './CollectionCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CollectionSection({
  buttonText,
  cards,
  collectionId,
  collectionSlug,
  description,
  href,
  productType,
  sectionIndex,
  title
}) {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const collectionIdNumber = typeof collectionId === 'number' ? collectionId : undefined;
  const section = typeof collectionId === 'string' ? collectionId : collectionSlug;
  const trackButtonClicked = () => {
    const eventData = {
      action: 'collection card clicked',
      itemIndex: sectionIndex,
      section,
      subscreen: 'collection section',
      type: productType
    };
    if (collectionIdNumber) {
      eventData.collectionId = collectionIdNumber;
    }
    trackMarketplaceEvent(getMarketplaceInteractionEvent(eventData));
  };
  const trackStubClicked = (item, index) => () => {
    trackMarketplaceEvent(getSearchResultClickedEvent({
      componentType: 'EcosystemCardSmall',
      listingId: item.listingId,
      resultCount: cards.length,
      resultIndex: index,
      resultType: 'LISTING',
      slug: item.slug,
      sourceId: getSourceIdByCard(item),
      subscreen: 'collection section',
      type: productType
    }));
  };
  return /*#__PURE__*/_jsx(CardWrapper, {
    "data-test-id": "collection-section",
    marginBlockEnd: "1000",
    children: /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsxs(Grid, {
        rowGap: "800",
        children: [/*#__PURE__*/_jsx(GridItem, {
          size: {
            xs: 12,
            lg: 6
          },
          children: /*#__PURE__*/_jsx(CollectionCard, {
            buttonText: buttonText,
            description: description,
            href: href,
            name: title,
            onClick: trackButtonClicked,
            removeCardWrapper: true,
            slug: collectionSlug
          })
        }), /*#__PURE__*/_jsx(GridItem, {
          size: {
            xs: 12,
            lg: 6
          },
          children: /*#__PURE__*/_jsx(Grid, {
            rowGap: "800",
            children: cards.map((item, index) => {
              var _item$iconUrl, _item$listingName, _item$providerName;
              return /*#__PURE__*/_jsx(GridItem, {
                size: {
                  xs: 12,
                  md: 4,
                  lg: 6
                },
                children: /*#__PURE__*/_jsx(SearchResultViewTracker, {
                  componentType: "EcosystemCardSmall",
                  collectionId: collectionIdNumber,
                  listingId: item.listingId,
                  resultCount: cards.length,
                  resultIndex: index,
                  resultType: "LISTING",
                  section: section,
                  slug: item.slug,
                  sourceId: getSourceIdByCard(item),
                  subscreen: "collection section",
                  type: productType,
                  children: /*#__PURE__*/_jsx(EcosystemCardSmall, {
                    imageSrc: (_item$iconUrl = item.iconUrl) !== null && _item$iconUrl !== void 0 ? _item$iconUrl : '',
                    linkMode: "react-router",
                    listingHref: `/listing/${item.slug}`,
                    name: (_item$listingName = item.listingName) !== null && _item$listingName !== void 0 ? _item$listingName : '',
                    onClick: trackStubClicked(item, index),
                    productType: "APP",
                    providerName: (_item$providerName = item.providerName) !== null && _item$providerName !== void 0 ? _item$providerName : 'HubSpot'
                  })
                })
              }, item.listingId);
            })
          })
        })]
      })
    })
  });
}